import { defineStyleConfig } from '@chakra-ui/react';

export const TagStyle = defineStyleConfig({
  defaultProps: {
    colorScheme: 'brand',
    variant: 'solid',
  },
});
